import { FC } from 'react';
import { ProjectDetailsContainer } from '../components/project-details.container';

export const ProjectDetailsPage: FC<any> = (props) => {
  return <ProjectDetailsContainer />;
};
